<template>
  <div v-if="
  this.enableAccessAuthCreate('W1', this.getUser.pref.select.fauth) === true">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        add
      </v-icon>
      {{this.data.btnTitle}}
    </v-btn>
    <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
      v-else-if="this.data.btnSize === 'iconAdd'">
      <v-icon>
        add
      </v-icon>
    </v-btn>
    <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
    v-else>
      <v-icon>
        build
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Work Request
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="build"
                  hint="work request title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <span v-if="this.workRequestAsset.id === ''">
                    <v-avatar>
                      <v-icon :color="ui.colorWarning"> emoji_transportation </v-icon>
                    </v-avatar>
                    <span :class="ui.textWarning">
                      Select Asset
                    </span>
                  </span>
                  <span v-else>
                    <v-avatar>
                      <v-icon :color="ui.colorBlue1"> emoji_transportation </v-icon>
                    </v-avatar>
                    <span :class="ui.textSubheading">
                      Work Request Asset
                    </span>
                  </span>
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout row wrap class="ml-3 mr-2 mt-2">
                <v-flex xs11>
                  <v-text-field
                  :label="workRequestAsset.title"
                  prepend-icon="title"
                  hint="asset name"
                  persistent-hint
                  readonly
                  outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-3 mr-2">
                <v-flex xs11>
                  <v-text-field
                  :label="workRequestAsset.id"
                  prepend-icon="fingerprint"
                  hint="asset tag"
                  persistent-hint
                  readonly
                  outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading"
              v-if="this.getCurrentPage !== '/registerlist'">
                <v-spacer/>
                <Append :data="{tag: 'A1'}"/>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.type"
                    :items="workTypeOptions"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="work type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.theme"
                    :items="workThemeOptions"
                    color="wplblue0"
                    prepend-icon="yard"
                    hint="work theme"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.itemDis"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="work discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-3 mr-2 mt-4">
                <v-flex xs11>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="work request"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="reported fault or issue or activity"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_transportation </v-icon>
                  </v-avatar>
                  Asset Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{workRequestAsset.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_transportation </v-icon>
                  </v-avatar>
                  {{workRequestAsset.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Asset Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{workRequestAsset.id}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{workRequestAsset.id}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> category </v-icon>
                  </v-avatar>
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> yard </v-icon>
                  </v-avatar>
                  Theme
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> yard </v-icon>
                  </v-avatar>
                  {{localForm.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Discipline
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemDis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  {{localForm.itemDis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build </v-icon>
                  </v-avatar>
                  Work
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build </v-icon>
                  </v-avatar>
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createWorkRequest()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createWorkRequest()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import Append from "@/data/append/components/Append";
import link from "@/data/forms/mixins/link.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin,
    Append
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    link,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    workOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    transFunctions,
    describeDocument,
    techOptions,
    numberFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  beforeMount() {
    if (this.getOriginal !== null && this.getOriginal !== undefined) {
      this.localForm.title = this.getOriginal.basic.title;
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        title: "Inspect ...",
        des: "Complete test ...",
        type: "B1",
        theme: "Check",
        itemDis: "Electrical",
        adid: "",
        aid: "",
        aidg: "",
        at: "",
        atag: ""
      },
      info: [
        {
          step: 0,
          title: "Work Request",
          // eslint-disable-next-line
          msg: "Create work request for maintenance or project. Work request enables release of resources to plan and execute facility repair, replace, upgrade and inspection activities.",
          icon: ""
        },
        {
          step: 1,
          title: "Work Request Type",
          // eslint-disable-next-line
          msg: "Work request type definition allows faster prioritisation of resources, planning, budget allocation and completion of work by the right execution team.",
          icon: ""
        },
        {
          step: 2,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. If you need to edit entered data then return to previous steps.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getFacility",
      "getDetailBasic",
      "getCurrentPage",
      "getOriginal",
      "getDetailLink"
    ]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    workRequestAsset() {
      let obj = {
        title: "",
        id: ""
      };
      if (this.data.info !== undefined && this.data.info !== null) {
        obj.title = this.data.info.basic.title;
        obj.id = this.data.info.basic.id;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic.tag === "A1"
      ) {
        obj.title = this.getDetailBasic.title;
        obj.id = this.getDetailBasic.id;
      } else if (this.getDetailLink !== null && this.getDetailLink !== null) {
        if (this.getDetailLink.at !== "") {
          obj.title = this.getDetailLink.at;
          obj.id = this.getDetailLink.aid;
        }
      } else {
        if (this.getDetailBasic !== null && this.getDetailBasic !== undefined) {
          if (this.getDetailBasic.tag === "A1") {
            obj.title = this.getDetailBasic.title;
            obj.id = this.getDetailBasic.id;
          }
        }
      }
      return obj;
    },
    enableSubmit() {
      let logic = false;
      if (
        this.step === 2 &&
        this.btnSpinChangeDetail === false &&
        this.workTypeOptions.id !== ""
      ) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (
        this.step == 0 &&
        this.localForm.title !== "" &&
        this.workTypeOptions.id !== "" &&
        this.workRequestAsset.id !== ""
      ) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.type !== "" &&
        this.localForm.theme !== "" &&
        this.localForm.itemDis !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      this.btnSpinChangeDetail = false;
      // this.localForm.title = "";
      // this.localForm.des = "";
      // this.localForm.type = "";
      // download facility which is used for asset
      // generate get detail link to enable the asset to be apprended
      if (this.getDetailLink === null) {
        this.$store.dispatch("changeDetailLink", this.formLinkWorkRequest);
      }
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createWorkRequest() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "W1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");
      const id = "W" + this.defineIDGShortLastSix(idg);
      // GERATE form
      let temp = this.generateWorkRequestForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.id = id;
      temp.basic.tag = tag;
      temp.basic.act = true; // set to true
      temp.basic.title = this.localForm.title;

      // CHAR
      temp.char.req = this.localForm.des;
      temp.char.type = this.localForm.type;
      temp.char.theme = this.localForm.theme;
      temp.char.dis = this.localForm.itemDis;
      temp.char.des = this.localForm.des;

      // STATS
      temp.stats.dcrt = moment().format();
      // eslint-disable-next-line
      temp.stats.drev = moment().add(2, 'months').format();
      // eslint-disable-next-line
      temp.stats.ddue = moment().add(3, 'months').format();
      // eslint-disable-next-line
      temp.stats.dstr = moment().add(1, 'years').format();
      // eslint-disable-next-line
      temp.stats.dend = moment().add(2, 'years').format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // LINK DATA
      if (
        this.data.info !== undefined &&
        this.data.info !== undefined &&
        this.data.info.basic.tag === "A1"
      ) {
        temp.link.adid = this.data.info.basic.did;
        temp.link.aid = this.data.info.basic.id;
        temp.link.aidg = this.data.info.basic.idg;
        temp.link.at = this.data.info.basic.title;
        temp.link.atag = this.data.info.basic.tag;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic !== undefined &&
        this.getDetailBasic.tag === "A1"
      ) {
        temp.link.adid = this.getDetailBasic.did;
        temp.link.aid = this.getDetailBasic.id;
        temp.link.aidg = this.getDetailBasic.idg;
        temp.link.at = this.getDetailBasic.title;
        temp.link.atag = this.getDetailBasic.tag;
      } else if (
        this.getDetailLink !== null &&
        this.getDetailLink !== undefined
      ) {
        temp.link = this.getDetailLink;
      } else {
        temp.link.adid = this.localForm.adid;
        temp.link.aid = this.localForm.aid;
        temp.link.aidg = this.localForm.aidg;
        temp.link.at = this.localForm.at;
        temp.link.atag = this.localForm.atag;
      }

      // HELP
      console.log("");
      console.log(">>> NEW WORK REQUEST <<<");
      console.log(temp);

      // Create Noti
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
